import React from "react"
import {Button, Table} from "antd";
import {useParams} from "react-router";
import {useGetOnceHttp} from "../hooks/inithttp.hook";
import {Link} from "react-router-dom";
import {defaultSorter} from "../utils/antdhelper/AntdHelper";


const NsisPage = ({}) => {
    const {nsi} = useParams()
    const [data] = useGetOnceHttp({url: `/api/nsi/all`, method: 'POST', def: []})
    const columns = [
        {
            title: "Название",
            dataIndex: "caption"
        },
        {
            title: "oid",
            dataIndex: "oid"
        },
        {
            title: "Версия",
            dataIndex: "version"
        },
        {
            title: "Действия",
            dataIndex: "oid",
            render: (oid) => <Button><Link to={`/nsi/${oid}`}> Просмотр</Link></Button>
        }
    ].map(column => ({...column, sorter: defaultSorter(column)}))
    return <Table
        dataSource={data}
        columns={columns}
        rowKey={"oid"}
    />
}

export default  NsisPage